export const setPlayer = (player) => ({
    type: 'SET_PLAYER',
    player: player
});

export const setCategoryName = (category) => ({
    type: 'SET_CATEGORY',
    category: category
})
